import { render, staticRenderFns } from "./AppDeviceHardwareInfo.vue?vue&type=template&id=1c152ab2&scoped=true&"
import script from "./AppDeviceHardwareInfo.vue?vue&type=script&lang=js&"
export * from "./AppDeviceHardwareInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c152ab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
